import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom"
import Button from "../Button"
import jumpToChat from "../../utils/jumpToChat";
import styles from "./styles.module.scss"

function Header () {
  const path = useLocation().pathname

  const [fix, setFix] = useState(false)

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollY = window.scrollY
      if(scrollY > 70) {
        setFix(true)
      } else {
        setFix(false)
      }
    })
  }, [])

  const content = <>
    <img src={"./static-official/images/logo-header.svg"} alt="xiniu logo" />
    <div className={styles.nav}>
      <nav>
        <ul>
          <li className={path === `/` ? styles.active : ""}> <div className={styles.navItem}><Link to="/">首页</Link></div> </li>
          <li onClick={() => {jumpToChat()}}><div className={styles.navItem}>烯牛先见</div></li>
          <li className={path.startsWith('/productions') ? styles.active : ""}>
            <div className={styles.navItem}><Link to="/productions">产品</Link></div>
          </li>
          <li className={path.startsWith('/solutions') ? styles.active : ""}>
            <div className={styles.navItem}>解决方案</div>
            <div className={styles.popup} style={{width: "168px"}}>
              <Link to="/solutions/a">私募股权投资</Link>
              <Link to="/solutions/b">政府招商引资</Link>
              <Link to="/solutions/c">银行科创金融</Link>
              <Link to="/solutions/d">券商科创金融</Link>
            </div>
          </li>
          <li className={path.startsWith('/data') ? styles.active : ""}>
            <div className={styles.navItem}><Link to="/data">数据</Link></div>
          </li>
          <li className={path.startsWith('/research') ? styles.active : ""}>
            <div className={styles.navItem}><Link to="/research">烯牛研究院</Link></div>
          </li>
          <li>
            <div className={styles.navItem}>
              <a href="#/mcp" target="_blank" rel="noreferrer">烯牛MCP</a>
            </div>
          </li>
        </ul>
        <div style={{display: "flex", alignItems: "center", gap: "2px", minWidth: "240px"}}>
          <Button className={styles.imageBtn} onClick={() => {window.open("https://open.xiniudata.com/")}}>
            <img src="/static-official/images/mcp_desc_button_xiniu.png" alt="烯牛开放平台"/>
          </Button>
          <Button className={styles.imageOldBtn} onClick={() => {window.open("https://vip.xiniudata.com/")}}>PC版</Button>
          
          {/*<Button type="default" onClick={() => {window.open("https://free.xiniudata.com/")}}>PC个人版</Button>*/}
          <Button className={styles.imageOldBtn} type="default">
            <div className={styles.downloadContainer}>APP下载
              <div className={styles.popup} style={{width: "155px", padding: "15px 15px 10px"}}>
                <div className={styles.download}>
                  <img src="/static-official/images/app.png" alt="扫一扫下载APP" width={130}/>
                  <div className={styles.download_hint}>扫一扫下载APP</div>
                </div>
              </div>
            </div>
          </Button>
        </div>
      </nav>
    </div>
  </>

  return <>
    {fix ? <div className={styles.header}>
      {content}
    </div> : null}
    <header>
      {content}
    </header>
  </>
}

export default Header
